<div>
  <div
    class="progress c-pointer"
    (click)="onclickProgress($event)"
    style="background-color: transparent"
    id="padre"
  >
    <div
      id="hijo"
      class="progress position-relative bg-secondary"
      [style.width.%]="100"
      [style.marginLeft.%]="progress.coord_min"
      [style.marginRight.%]="progress.coord_max"
      style="z-index: -1"
    ></div>
  </div>
</div>

<!-- <mat-slider min="200" max="500">
  <input value="300" matSliderStartThumb />
  <input value="400" matSliderEndThumb />
</mat-slider>

<mat-slider
  thumbLabel
  [displayWith]="formatLabel"
  tickInterval="1000"
  step="1000"
  min="0"
  max="100000"
  aria-label="units"
></mat-slider>
 -->
